import styled from 'styled-components';

const PageTopSectionStyle = styled.div`
	&.page-top-section-container-wrap {
		.description {
			max-width: var(--sp41x);
			margin-bottom: var(--descToBtn);
		}

		.TextSizeSmall {
			margin-top: var(--titleToText);
			margin-bottom: var(--textToDescription);
		}

		.titleWrapCont {
			.topAnimationWrap {
				position: relative;
				transform: translate3d(0, -50%, 0);
				padding-top: 50%;
				width: 100%;
				mix-blend-mode: difference;

				> div {
					position: absolute;
					top: 0;
					right: 0;
					width: 100%;
					height: 100%;
				}
			}
		}

		.topBtnAnimationWrap {
			.topBtnArrow {
				position: absolute;
				z-index: 1;

				svg {
					path:first-child {
						fill: var(--color2);
					}
				}
			}

			.otherLinkWrap {
				position: relative;
				z-index: 2;
			}
		}

		.title span,
		.topBtnAnimationWrap .topBtnArrow,
		.topBtnArrow ~ a,
		.description,
		.TextSizeSmall,
		.otherInfo {
			opacity: 0;
		}

		.item-2 {
			font-weight: var(--ffSemiBold);
		}

		.otherInfo {
			margin-top: var(--sectionToSection);
			line-height: var(--lineHeightH5) !important;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
			.topBtnAnimationWrap {
				text-align: right;
				position: relative;
				margin-top: var(--sp3x);
				margin-right: var(--sp4x);

				.topBtnArrow {
					width: 74px;
					right: -20px;
					bottom: 75%;
					transform: rotate(22deg);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.description {
				max-width: 100%;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.titleWrap {
				position: relative;
				display: inline-block;
			}

			.topBtnAnimationWrap {
				position: absolute;
				right: var(--sp20x);
				bottom: calc(var(--sp8x) * -1);
				transform: translateX(100%) rotate(18deg);

				.topBtnArrow {
					width: 95px;
					left: 0;
					bottom: 30%;
					transform: rotate(-29deg);
				}
			}

			.description {
				margin-top: var(--textToDescription);
			}

			.TextSizeSmall {
				max-width: 52%;
			}

			.titleWrapCont {
				position: relative;

				.topAnimationWrap {
					position: absolute;
					top: 50%;
					right: 0;
					width: 50%;

					> div {
						position: absolute;
						top: 0;
						right: 0;
						width: 100%;
						height: 100%;
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			.topBtnAnimationWrap {
				position: absolute;
				right: var(--sp2x);
				bottom: calc(var(--sp2x) * -1);
			}

			.TextSizeSmall {
				margin-left: 48%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			.description {
				max-width: 86%;
			}

			.topBtnAnimationWrap {
				bottom: var(--sp6x);
				right: calc(var(--sp6x) * -1);

				.topBtnArrow {
					bottom: 40%;
					transform: rotate(-40deg);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			.description {
				max-width: 92%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: 1441px) {
			.topBtnAnimationWrap {
				bottom: var(--sp9x);
				right: calc(var(--sp7x) * -1);

				.topBtnArrow {
					width: 115px;
					bottom: 25%;
					left: calc(var(--sp4x) * -1);
					transform: rotate(-50deg);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			.topBtnAnimationWrap {
				bottom: var(--sp5x);
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			.topBtnAnimationWrap {
				.topBtnArrow {
					width: 145px;
					bottom: 30%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			margin-bottom: var(--sp10x);

			.description {
				max-width: 90%;
			}

			.topBtnAnimationWrap {
				bottom: var(--sp12x);

				.topBtnArrow {
					width: 165px;
					bottom: 50%;
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			margin-bottom: var(--sp15x);

			.description {
				max-width: 75%;
			}

			.topBtnAnimationWrap {
				bottom: var(--sp15x);
				right: calc(var(--sp16x) * -1);

				.topBtnArrow {
					width: 277px;
					bottom: 0%;
					left: -50%;
					transform: rotate(-50deg);
				}
			}
		}
	}
`;

export default PageTopSectionStyle;
